export const idtypes = [
  { value: 'passport', label: 'Passport' },
  { value: 'dlicense', label: `Driver's License` },
  { value: 'nondriverid', label: 'Non-Driver State ID' },
  { value: 'ssnumber', label: 'Social Security Number' }
];
